<script setup lang="ts">
import {
  FEHLT_NOCH,
  IFahrer,
  IST_ABGERECHNET,
  NICHT_ABGERECHNET,
} from "@/features/abrechnung/api/useAbrechnungsplan";
import {
  CheckCircleIcon,
  XCircleIcon,
  Cog8ToothIcon,
} from "@heroicons/vue/20/solid";

defineProps<{ abrechnungsstatus: IFahrer["abrechnungsstatus"] }>();
</script>

<template>
  <CheckCircleIcon
    v-if="abrechnungsstatus === IST_ABGERECHNET"
    class="inline-block w-5 h-5 text-green-500"
  />
  <Cog8ToothIcon
    v-if="abrechnungsstatus === NICHT_ABGERECHNET"
    class="inline-block w-5 h-5 text-orange-500"
  />
  <XCircleIcon
    v-if="abrechnungsstatus === FEHLT_NOCH"
    class="inline-block w-5 h-5 text-red-500"
  />
</template>
